<span>
  @if (!log?.staffId && log?.staffName === 'Everon Admin') {
    <strong>
      Everon Admin
    </strong>
  } @else {
    <a [routerLink]="['/staff', $safeNavigationMigration(log?.staffId)]" (click)="closeDialog.emit()">
      {{ log?.staffName }} ({{ log?.staffId }})
    </a>
  }

  <span>
    {{ $safeNavigationMigration(log?.details?.translationCode) | translate }}
  </span>
</span>
<p class="mt-1">{{ $safeNavigationMigration(log?.timestamp) | moment : "l LTS" }}</p>
<hr />

<div class="container">
  @if (activeGroups?.length) {
    <span class="item-title">{{ "SELECTED_RECEIVER_TEAMS" | translate }}:</span>
    <div class="details-box">
      <span class="item-value d-flex align-items-baseline">
        @if (activeGroups?.length) {
          <div class="device-list">
            @for (group of activeGroups; track group) {
              <div
                class="positive-highlight mt-1 mb-1 ml-2 d-inline-block"
                >
                {{ group.GroupName }} ({{ group.GroupId }})
              </div>
            }
          </div>
        }
      </span>
    </div>
  }
</div>